import { Component, Input, OnInit } from '@angular/core'
import { InquirySharedDialogsService } from '@tv3/containers/inquiries/dialogs/inquiry-shared-dialogs.service'
import { Inquiry, isBookingFromAirbnb } from '@tv3/store/inquiry/inquiry.model'
import { BehaviorSubject } from 'rxjs'
import { filter, map, switchMap } from 'rxjs/operators'
import {
  isSomething,
  untilDestroy,
  Rental,
  Destroyable,
  DataCheckerService,
  DialogService,
} from '@tokeet-frontend/tv3-platform'
import { InquiryService } from '@tv3/store/inquiry/inquiry.service'
import * as moment from 'moment'
import { SmartDevicesGuard } from '@tokeet-frontend/smart-devices'
export interface BookingDetails {
  numAdults?: number
  numChild?: number
  rental?: Rental
  guestArrive?: number
  guestDepart?: number
  checkIn?: moment.Moment
  checkOut?: moment.Moment
  timezone?: string
}

@Component({
  selector: 'app-overlay-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss'],
})
export class BookingDetailsComponent extends Destroyable implements OnInit {
  private inquiry$ = new BehaviorSubject<Inquiry>(null)
  @Input() set inquiry(inquiry: Inquiry) {
    this.inquiry$.next(inquiry)
  }
  get inquiry() {
    return this.inquiry$.value
  }
  @Input() readonly = true
  @Input() showTimeZoneSource = true

  details: BookingDetails

  get isAirbnbAPIBooking() {
    return isBookingFromAirbnb(this.inquiry)
  }

  isLoading = false

  constructor(
    private dialog: DialogService,
    private sharedDialogsService: InquirySharedDialogsService,
    private inquiryService: InquiryService,
    private dataChecker: DataCheckerService
  ) {
    super()
    this.dataChecker.check([SmartDevicesGuard])
  }

  ngOnInit() {
    this.inquiry$
      .pipe(
        filter(isSomething),
        switchMap((inquiry) =>
          this.inquiryService.prepareCheckInOut(inquiry).pipe(
            map((checkInOut) => ({
              ...inquiry,
              ...checkInOut,
            }))
          )
        ),
        untilDestroy(this)
      )
      .subscribe((details) => {
        this.details = details
      })
  }

  onUpdateDetails() {
    this.sharedDialogsService.openUpdateDetails(this.inquiry)
  }

  onLinkDevice() {
    this.dialog.closeAll()
  }
}
